import {logError} from "./logging.js";

/**
 * Returnerar true om obj är en promise.
 * @param {any} obj 
 * @returns {bool}
 */
const isPromise = obj => {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function" && typeof obj.catch === "function";
    // return obj instanceOf Promise;
};

/*
  Middleware som fångar exceptions som slängs inuti en action som kan vara en thunk, vanlig funktion eller en promise.
  Dessa fel skickas till loggern.
  @param {Object} store - Redux store
 */
export const errorHandler = store => next => action => {
    try {
        const what = next(action);

        if (isPromise(what)){
            return what.catch(e => {
                logError(store.getState(), e);
                throw e;
            });
        }
        return what;
    } catch (e) {
        logError(store.getState(), e);
        throw e;
    }
};

